module.exports = __webpack_public_path__ + "img/linkd2-3.8572873f.webp";